import { Icon } from './Icon';

export interface ToastItem {
  id: number;
  tone: 'info' | 'success' | 'warning' | 'error';
  message: string;
}

interface ToastsProps {
  toasts: ToastItem[];
  onDismiss: (id: number) => void;
}

const icons = {
  info: 'spark',
  success: 'check',
  warning: 'rift',
  error: 'rift',
} as const;

export function Toasts({ toasts, onDismiss }: ToastsProps) {
  return (
    <div className="toasts" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast--${toast.tone}`} role="status">
          <span className="toast__icon">
            <Icon name={icons[toast.tone]} size={17} />
          </span>
          <span>{toast.message}</span>
          <button type="button" className="toast__close" onClick={() => onDismiss(toast.id)} aria-label="Cerrar aviso">
            <Icon name="close" size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
